// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2M_U9","type":"styles_type__33URe","choices":"styles_choices__3Bta-"};